import AddSpecimen from './add-specimen';

export default AddSpecimen;
